import { post } from "./request";
import { appid, backUrlForCode } from "./constant";
import cookies from "js-cookie";
import { getUrlParam } from "./util";
import { promises } from "fs";

export const getUrlForCode = function () {
    const scope = "snsapi_userinfo";
    const redirectUrl = encodeURIComponent(backUrlForCode);
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`;
};

export const getOpenidByCode = function () {
    return new Promise(function (resolve, reject) {
        post({
            url: "/gateway/manageBedrock/wechatcs/getSessionKey",
            data: {
                appKey: "wx_gzh",
                authCode: cookies.get("code"),
                // appid: appid,
                // grant_type: "authorization_code",
            },
        }).then((res) => {
            const openid = res.data && res.data.openId;
            const access_token = res.data && res.data.sessionKey;
            cookies.set("openid", openid, {
                path: "/",
            });
            cookies.set("access_token", access_token, {
                path: "/",
            });
            resolve(res);
        });
    });
};

export const getWxLogin = function (currRoute) {
    currRoute = currRoute || {};
    return new Promise(function (resolve, reject) {
        if (currRoute.isWxLogin === false) {
            resolve();
            return;
        }
        if (cookies.get("openid") && cookies.get("openid") !== "null") {
            resolve();
            return;
        }
        const code = getUrlParam("code"); //|| cookies.get('code');
        if (code) {
            cookies.set("code", code, {
                path: "/",
            });
            getOpenidByCode().then((res) => {
                getWxUserInfo(res.data).then((data) => {
                    resolve();
                });
            });
        } else {
            window.location.href = getUrlForCode();
        }
    });
};

export const getWxUserInfo = function (data) {
    return new Promise(function (resolve, reject) {
        const access_token = data.access_token;
        const openid = data.openid;
        if (!access_token || !openid) {
            resolve();
            return;
        }
        post({
            url: "/gateway/manageBedrock/wechatcs/getUserInfo",
            data: {
                appKey: "wx_gzh",
                accessToken: access_token,
                openId: openid,
                // lang: "zh_CN",
            },
        }).then((res) => {
            console.log(8888888, res);
            if (res && res.data) {
                // const data = JSON.parse(res.data);
                let data;
                try {
                    data = JSON.parse(res.data);
                } catch (err) {
                    data = res.data;
                }
                cookies.set("nickname", data.nickName, {
                    path: "/",
                });
                resolve(data);
            }
        });
    });
};



// WEBPACK FOOTER //
// ./src/utils/wxLogin.js